import React from 'react';
import { Breadcrumb } from 'semantic-ui-react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Page, { PageType } from '@constants/page';
import useGetUploadById from '@api/upload/hooks/useGetUploadById';

type Props = {
  page: PageType;
  isCurrentPage: boolean;
  entityId?: string | undefined;
};

function BreadcrumbStep({ page, isCurrentPage, entityId }: Props) {
  const { t } = useTranslation();
  const { uploadDTO } = useGetUploadById(Number(entityId), {
    enabled: entityId !== undefined && !Number.isNaN(entityId),
  });
  const params = useParams();

  let stepPath = page.path;
  Object.entries(params).forEach(([key, value]) => {
    stepPath = stepPath.replace(`:${key}`, String(value));
  });

  return (
    <>
      <Breadcrumb.Divider icon={page === Page.HOME ? 'home' : 'right chevron'} />
      <Breadcrumb.Section active={isCurrentPage} link={!isCurrentPage}>
        {isCurrentPage ? (
          ` ${t(page.message)}  ${uploadDTO?.name ?? ''}`
        ) : (
          <Link to={stepPath} key={entityId}>
            {` ${t(page.message)} ${uploadDTO?.name ?? ''}`}
          </Link>
        )}
      </Breadcrumb.Section>
    </>
  );
}

BreadcrumbStep.defaultProps = {
  entityId: undefined,
};

export default BreadcrumbStep;
